import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../../hooks/useScrollAnimation';

interface SectionHeadingProps {
  eyebrow: string;
  headline: string;
  subheadline?: string;
  center?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  headline,
  subheadline,
  center = true,
}) => {
  return (
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-100px' }}
      className={center ? 'text-center' : ''}
    >
      <motion.p variants={fadeInUp} className="text-eyebrow uppercase text-esf-blue mb-4">
        {eyebrow}
      </motion.p>
      <motion.h2 variants={fadeInUp} className="text-display-lg text-esf-white text-balance">
        {headline}
      </motion.h2>
      {subheadline && (
        <motion.p
          variants={fadeInUp}
          className={`mt-5 text-body-lg text-esf-gray-300 max-w-2xl text-pretty ${
            center ? 'mx-auto' : ''
          }`}
        >
          {subheadline}
        </motion.p>
      )}
    </motion.div>
  );
};

export default SectionHeading;
